function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 16,
  fill: "#E5E5E5"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 375,
  height: 1321,
  transform: "translate(-231 -880)",
  fill: "#F7F7F7"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: -231,
  y: -824,
  width: 375,
  height: 1265,
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  d: "M-62 -15C-62 -19.4183 -58.4183 -23 -54 -23H72C76.4183 -23 80 -19.4183 80 -15V156C80 160.418 76.4183 164 72 164H-54C-58.4183 164 -62 160.418 -62 156V-15Z",
  fill: "#333333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.2416 1.31396H0.677734V14.8785H17.2416V1.31396Z",
  stroke: "white",
  strokeWidth: 1.13373,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.677734 12.4438L5.09172 8.09217L8.95964 10.907L15.1787 4.07214L17.2415 6.22371",
  stroke: "white",
  strokeWidth: 1.13373,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.42121 7.46163C9.34689 7.46163 10.0973 6.66131 10.0973 5.67405C10.0973 4.6868 9.34689 3.88647 8.42121 3.88647C7.49553 3.88647 6.74512 4.6868 6.74512 5.67405C6.74512 6.66131 7.49553 7.46163 8.42121 7.46163Z",
  stroke: "white",
  strokeWidth: 1.13373,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: -263.851,
  y: -853.566,
  width: 440.702,
  height: 1330.7,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.28511
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 16.4255
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 375,
  height: 1321,
  fill: "white",
  transform: "translate(-231 -880)"
})));

var SvgLandscape = function SvgLandscape(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLandscape, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/landscape.cb683008.svg";
export { ForwardRef as ReactComponent };